import { useMemo } from "react";
import { titles } from "@/mocks/titles";
import { newsList } from "@/mocks/news";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestUpdates from "./components/LatestUpdates";
import FeaturedGrid from "./components/FeaturedGrid";
import NewsHighlight from "./components/NewsHighlight";
import SiteIntro from "./components/SiteIntro";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Home() {
  const featured = useMemo(() => titles.filter((t) => t.featured), []);
  const heroItems = useMemo(
    () => titles.filter((t) => t.featured && t.banner).slice(0, 4),
    []
  );
  const latest = useMemo(() => titles.slice(0, 12), []);
  const recommended = useMemo(
    () => [...titles].sort((a, b) => b.rating - a.rating).slice(0, 10),
    []
  );
  const topNews = useMemo(() => newsList.slice(0, 6), []);

  return (
    <div className="-mt-16">
      <HeroCarousel items={heroItems} />

      <div className="w-full px-4 md:px-8 py-10 md:py-14 space-y-12 md:space-y-16">
        <section>
          <SectionHeading
            title="分类快捷入口"
            subtitle="按类型快速进入，发现更多好内容"
            accentIcon="ri-apps-2-line"
          />
          <CategoryEntry />
        </section>

        <LatestUpdates items={latest} />

        <section>
          <SectionHeading
            title="精选推荐"
            subtitle={`编辑精选 ${featured.length} 部高口碑作品`}
            moreTo="/category/movie"
            accentIcon="ri-award-line"
          />
          <FeaturedGrid items={recommended} />
        </section>

        <section>
          <SectionHeading
            title="影视资讯精选"
            subtitle="最新行业动态与热剧追踪"
            moreTo="/news"
            accentIcon="ri-newspaper-line"
          />
          <NewsHighlight items={topNews} />
        </section>

        <SiteIntro />
      </div>
    </div>
  );
}